import React from "react";
import { Link } from "react-router";

export default function Contact() {
    return (
        <div className="container">
            <div className="home-container">
                <h1>Контакты</h1>
            </div>

            <div className="content-container">
                <b>Поддежка: support@raytolfas.com</b>
                <Link className="Link-button" to="/about">Перейти в "О нас"</Link>
            </div>
        </div>
    );
}
